import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import { AppRoutes } from "../../routes/routes";
import { Breadcrumb } from "../breadcrumb";
import { UserTabs } from "../user-tabs";
import { RegistrationsListView } from "./registrations-list-view";
import { RegistrationsSearchView } from "./registrations-search-view";
export const RegistrationsView = observer(() => {
    return (_jsxs("div", { children: [_jsx(Breadcrumb, {}), _jsxs("div", { className: "card mb-5", children: [_jsx("div", { className: "card-header", children: _jsx(UserTabs, { selected: AppRoutes.Registrations }) }), _jsx(RegistrationsSearchView, {}), _jsx(RegistrationsListView, {})] })] }));
});
